import React, { useState, useEffect } from "react";
import TooltipIcons from "../../../core/common/tooltip-content/tooltipIcons";
import RefreshIcon from "../../../core/common/tooltip-content/refresh";
import CollapesIcon from "../../../core/common/tooltip-content/collapes";
import { Link } from "react-router-dom";
import Table from "../../../core/pagination/datatable";
import {
  DollarSign,
  Download,
  Edit,
  Eye,
  PlusCircle,
  Trash2,
} from "feather-icons-react/build/IconComponents";
import { fetchSalesOrders } from "../../../api/salesOrderApi";
import OnlineorderModal from "./onlineorderModal";
import CommonDeleteModal from "../../../core/common/modal/commonDeleteModal";
import CommonFooter from "../../../core/common/footer/commonFooter";
import { openDetailsModal } from "./onlineorderModal";

const t = (key) => (window.translate ? window.translate(key) : key);

// Helper: detect if current language is RTL
const isRTL = () => document.documentElement.dir === "rtl";

const OnlineOrder = () => {
  const [salesOrders, setSalesOrders] = useState([]);
  const [salesDetails, setSalesDetails] = useState(null);

  useEffect(() => {
    const loadSalesOrders = async () => {
      try {
        const data = await fetchSalesOrders();
        const formatted = data.map((order) => ({
          id: order._id,
          _id: order._id,
          customer: `${order.customer?.firstName?.en || t("onlineOrderUnknown")} ${
            order.customer?.lastName?.en || ""
          }`,
          reference: order.reference,
          date: new Date(order.date).toLocaleDateString(),
          status: order.status,
          total: order.total?.toFixed(2),
          paid: order.paid?.toFixed(2),
          due:
            Math.abs(parseFloat(order.total) - parseFloat(order.paid)) < 0.01
              ? "0.00"
              : (order.total - order.paid).toFixed(2),
          paymentstatus: order.paymentStatus,
          biller: `${order.supplier?.firstName?.en || ""} ${
            order.supplier?.lastName?.en || ""
          }`,
        }));
        setSalesOrders(formatted);
      } catch (err) {
        console.error("Error loading sales orders", err);
      }
    };

    loadSalesOrders();
  }, []);

  // Reusable dropdown item style for LTR/RTL
  const dropdownItemStyle = {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexDirection: isRTL() ? "row-reverse" : "row",
    textAlign: isRTL() ? "right" : "left",
  };

  const columns = [
    {
      title: t("onlineOrderCustomerName"),
      dataIndex: "customer",
      render: (text) => (
        <div className="d-flex align-items-center">
          <Link to="#">{text}</Link>
        </div>
      ),
      sorter: (a, b) => a.customer.length - b.customer.length,
    },
    {
      title: t("Reference"),
      dataIndex: "reference",
      sorter: (a, b) => a.reference.length - b.reference.length,
    },
    {
      title: t("Date"),
      dataIndex: "date",
      sorter: (a, b) => a.date.length - b.date.length,
    },
    {
      title: t("Status"),
      dataIndex: "status",
      render: (render) => (
        <span
          className={`badge ${
            render === "Pending"
              ? "badge-cyan"
              : render === "Completed"
                ? "badge-success"
                : ""
          }`}
        >
          {t(render)}
        </span>
      ),
      sorter: (a, b) => a.status.length - b.status.length,
    },
    {
      title: t("onlineOrderGrandTotal"),
      dataIndex: "total",
      sorter: (a, b) => a.total.length - b.total.length,
    },
    {
      title: t("Paid"),
      dataIndex: "paid",
      sorter: (a, b) => a.paid.length - b.paid.length,
    },
    {
      title: t("Due"),
      dataIndex: "due",
      sorter: (a, b) => a.due.length - b.due.length,
    },
    {
      title: t("onlineOrderPaymentStatus"),
      dataIndex: "paymentstatus",
      render: (render) => (
        <span
          className={`badge badge-xs shadow-none ${
            render === "Unpaid"
              ? "badge-soft-danger"
              : render === "Paid"
                ? "badge-soft-success"
                : "badge-soft-warning"
          }`}
        >
          <i className="ti ti-point-filled me-1"></i>
          {t(render)}
        </span>
      ),
      sorter: (a, b) => a.paymentstatus.length - b.paymentstatus.length,
    },
    {
      title: t("Biller"),
      dataIndex: "biller",
      sorter: (a, b) => a.biller.length - b.biller.length,
    },
    {
      title: "",
      dataIndex: "action",
      render: (_, record) => (
        <>
          <Link
            className="action-set"
            to="#"
            data-bs-toggle="dropdown"
            aria-expanded="true"
          >
            <i className="fa fa-ellipsis-v" aria-hidden="true" />
          </Link>
          <ul className="dropdown-menu">
            <li>
              <Link
                to="#"
                className="dropdown-item"
                style={dropdownItemStyle}
                data-bs-toggle="modal"
                data-bs-target="#sales-details-new"
                onClick={() =>
                  openDetailsModal(record.id || record._id, setSalesDetails)
                }
              >
                <Eye size={16} className="flex-shrink-0" />
                <span>{t("onlineOrderSaleDetail")}</span>
              </Link>
            </li>
            <li>
              <Link
                to="edit-sales.html"
                className="dropdown-item"
                style={dropdownItemStyle}
                data-bs-toggle="modal"
                data-bs-target="#edit-sales-new"
              >
                <Edit size={16} className="flex-shrink-0" />
                <span>{t("onlineOrderEditSale")}</span>
              </Link>
            </li>
            <li>
              <Link
                to="#"
                className="dropdown-item"
                style={dropdownItemStyle}
                data-bs-toggle="modal"
                data-bs-target="#showpayment"
              >
                <DollarSign size={16} className="flex-shrink-0" />
                <span>{t("onlineOrderShowPayments")}</span>
              </Link>
            </li>
            <li>
              <Link
                to="#"
                className="dropdown-item"
                style={dropdownItemStyle}
                data-bs-toggle="modal"
                data-bs-target="#createpayment"
              >
                <PlusCircle size={16} className="flex-shrink-0" />
                <span>{t("onlineOrderCreatePayment")}</span>
              </Link>
            </li>
            <li>
              <Link to="#" className="dropdown-item" style={dropdownItemStyle}>
                <Download size={16} className="flex-shrink-0" />
                <span>{t("onlineOrderDownloadPdf")}</span>
              </Link>
            </li>
            <li>
              <Link
                to="#"
                className="dropdown-item mb-0"
                style={dropdownItemStyle}
                data-bs-toggle="modal"
                data-bs-target="#delete-modal"
              >
                <Trash2 size={16} className="flex-shrink-0" />
                <span>{t("onlineOrderDeleteSale")}</span>
              </Link>
            </li>
          </ul>
        </>
      ),
      sorter: (a, b) => a.createdby?.length - b.createdby?.length,
    },
  ];

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>{t("Sales")}</h4>
                <h6>{t("onlineOrderManageYourSales")}</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <TooltipIcons />
              <RefreshIcon />
              <CollapesIcon />
            </ul>
            <div className="page-btn">
              <Link
                to="#"
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#add-sales-new"
              >
                <i className="ti ti-circle-plus me-2 ms-2"></i>{" "}
                {t("onlineOrderAddSales")}
              </Link>
            </div>
          </div>

          <div className="card table-list-card manage-stock">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="search-set"></div>
              <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-2">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center d-none"
                    data-bs-toggle="dropdown"
                  >
                    {t("onlineOrderCustomer")}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Carl Evans
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Minerva Rameriz
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Robert Lamon
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Patricia Lewis
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown me-2">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center d-none"
                    data-bs-toggle="dropdown"
                  >
                    {t("Status")}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        {t("Completed")}
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        {t("Pending")}
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown me-2">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center d-none"
                    data-bs-toggle="dropdown"
                  >
                    {t("onlineOrderPaymentStatus")}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        {t("Paid")}
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        {t("Unpaid")}
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        {t("Overdue")}
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center d-none"
                    data-bs-toggle="dropdown"
                  >
                    {t("Sort By : Last 7 Days")}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        {t("Recently Added")}
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        {t("Ascending")}
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        {t("onlineOrderDescending")}
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        {t("Last Month")}
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        {t("Last 7 Days")}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body">
              <div className="custom-datatable-filter table-responsive">
                {salesOrders.length > 0 ? (
                  <Table columns={columns} dataSource={salesOrders} />
                ) : (
                  <div className="text-center py-5">
                    <p>{t("onlineOrderNoSalesOrdersFound")}</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <CommonFooter />
      </div>
      <OnlineorderModal salesDetails={salesDetails} />
      <CommonDeleteModal />
    </div>
  );
};

export default OnlineOrder;
